import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import injectSheet from 'react-jss'

import HorizontalHero from "./HorizontalHero"
import VerticalHero from "./VerticalHero"
import RelatedArticles from "./RelatedArticles"
import {getIsTrending, getArticles, getScreenBreakpoint} from "../../selectors"
import {ArticleStructuredDataComponent, FaqStructuredDataComponent} from '../StructuredDataComponent'
import LoadMoreArticlesButton from '../LoadMoreArticlesButton'
import CardGrid from '../Card/CardGrid'
import Section from '../Widgets/Section'
import Author from "../Widgets/Author"

import theme from "../../styles/theme"
import sliceMapper from './sliceMapper'

class Article extends PureComponent {
  render() {
      const {page, articles, variation, is_mobile} = this.props;
      const bodyItems = sliceMapper( page.body );

      return (
          <article>
              <ArticleStructuredDataComponent article={page} />
              <FaqStructuredDataComponent bodyItems={page.body} />
              {page.hero_type === "Vertical Hero" ? (
                <VerticalHero images={page.vertical_hero} article={page} isMobile={is_mobile} />
              ) : (
                <HorizontalHero images={page.horizontal_hero} article={page} isMobile={is_mobile} />
              )}
              <div style={{clear: "both"}}></div>
              {bodyItems}
              {page.author && <Author author={page.author} />}
              <RelatedArticles related_articles={page.related_articles} />
              {articles && articles.length > 0 && (
                <Section>
                    <CardGrid
                        columns={3}
                        items={articles}
                        singleLine={false}
                        carousel={false}
                        variation={variation}
                        showSummary={false}
                    />
                </Section>
              )}
              <LoadMoreArticlesButton key='load-more'/>
          </article>
        );
        }
}

const mapStateToProps = (state) => {
    return {
        is_trending: getIsTrending(state),
        articles: getArticles(state),
        is_mobile: getScreenBreakpoint(state) === theme.breakpoints.mobile ? true : false
    }
}

export default injectSheet({
    contentContainer: {
        paddingBottom: '1rem'
    },
    desktopContainer: {
        display: 'none',
        [theme.breakpoint("tablet")]: {
            display: 'block',
        }
    },
    mobileContainer: {
        display: 'block',
        [theme.breakpoint("tablet")]: {
            display: 'none',
        }
    },
    header: {
        marginBottom: 16,
        maxWidth: '90%',
        [theme.breakpoint("tablet")]: {
            maxWidth: '80%',
        }
    }
})( connect(mapStateToProps)(Article) );



// WEBPACK FOOTER //
// ./src/components/Article/index.js